<template>
  <div class="blog-author">
    <div class="media align-items-center">
      <div class="blog-author__img">
        <img :src="url" :alt="name" />
      </div>
      <div class="media-body">
        <h3>Автор новини - {{ name }}</h3>
        <h4></h4>
        <p v-if="position">{{ position }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BlogAuthor",
  props: {
    url: {
      type: String,
      required: true,
      default: ""
    },
    name: {
      type: String,
      required: true,
      default: ""
    },
    position: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped></style>
